function customizeHeaderMenu() {
  function isTouchDevice() {
    return (('ontouchstart' in window) ||
       (navigator.maxTouchPoints > 0) ||
       (navigator.msMaxTouchPoints > 0));
  }

  if (isTouchDevice()) {
    return;
  }

  // Only on desktop / non-touch devices, the top-level menu entries should be clickable to open the linked page directly.
  document.querySelectorAll("header-menu summary").forEach((summary) => {
    const headerMenu = summary.parentNode;
    
    headerMenu.addEventListener("mouseover", () => {
      headerMenu.setAttribute("open", true);
    });

    headerMenu.addEventListener("mouseout", () => {
      headerMenu.removeAttribute("open");
    });

    summary.addEventListener("click", (e) => {
      if (summary.dataset.url) {
        e.preventDefault();
        e.stopPropagation();

        window.location.href = summary.dataset.url;
      }
    })
  });
}

customizeHeaderMenu();